export enum SortOrder {
  Asc = 1,
  Desc = -1,
}
